
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { PendingAction } from './types';

export const useNavigationState = () => {
  const navigate = useNavigate();
  const { portfolioId } = useParams();
  const [activeTab, setActiveTab] = useState('general');
  const [selectedPortfolio, setSelectedPortfolio] = useState<string>('');
  const [showUnsavedChangesDialog, setShowUnsavedChangesDialog] = useState(false);
  const [pendingAction, setPendingAction] = useState<PendingAction | null>(null);

  // Initialize the selectedPortfolio state with the portfolioId from URL
  useEffect(() => {
    if (portfolioId && selectedPortfolio === '') {
      console.log('Setting selected portfolio from URL:', portfolioId);
      setSelectedPortfolio(portfolioId);
    }
  }, [portfolioId, selectedPortfolio]);

  // Add effect to navigate when selectedPortfolio changes
  useEffect(() => {
    if (selectedPortfolio && selectedPortfolio !== portfolioId) {
      console.log('Navigation state: Navigating to new portfolio:', selectedPortfolio);
      navigate(`/portfolio/${selectedPortfolio}/settings`);
    }
  }, [selectedPortfolio, portfolioId, navigate]);

  const executePendingAction = () => {
    if (pendingAction) {
      if (pendingAction.type === 'tab') {
        setActiveTab(pendingAction.value || 'general');
      } else if (pendingAction.type === 'back') {
        navigate('/');
      } else if (pendingAction.type === 'portfolio') {
        setSelectedPortfolio(pendingAction.value || '');
        // The navigation will happen through the useEffect above
      }
      setPendingAction(null);
      setShowUnsavedChangesDialog(false);
    }
  };

  return {
    navigate,
    activeTab,
    setActiveTab,
    selectedPortfolio,
    setSelectedPortfolio,
    showUnsavedChangesDialog,
    setShowUnsavedChangesDialog,
    pendingAction,
    setPendingAction,
    executePendingAction
  };
};
